import { EnvironmentId, type ConnectDesktopBridge } from "@afar-research/contracts";
import { reconnectCloudWorkspace } from "./cloudWorkspaceRegistration";
import { addConnectEnvironment, connectAccountKey } from "./connectEnvironments";

/** Register the same network introduction whether chosen from Network settings or its parent's guest list. */
export async function connectNetworkEnvironment(
  account: ConnectDesktopBridge,
  target: { networkId: string; machineId: string },
) {
  if (!account.networks) throw new Error("AFAR Network connections are unavailable here.");
  const outcome = await account.networks.connectNetworkMachine(target);
  if (outcome._tag === "NetworkMachineRefused") return outcome;
  const status = await account.getStatus();
  if (status.state !== "signed-in") throw new Error("The account is signed out.");
  await addConnectEnvironment(
    connectAccountKey(status.activeAccountId),
    EnvironmentId.make(outcome.environmentId),
  );
  reconnectCloudWorkspace({ id: outcome.environmentId, label: outcome.label });
  return outcome;
}
